import classNames from "classnames";

import { MoreIcon } from "../../AscIcons";

import styles from "./AscResourceCard.module.scss";
import AscAdminAction from "../../AscAdminAction/AscAdminAction";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import { useOutsideClick } from "@ascendnow/shared";

export interface AscResourceCard {
  type: string;
  title: string;
  format?: string;
  className?: string;
  imageUrl: string;
  loading?: boolean;
  onEdit?: () => void;
  onRemove?: () => void;
}

export default function AscResourceCard({
  type,
  title,
  format,
  className,
  imageUrl,
  loading = false,
  onEdit,
  onRemove,
}: AscResourceCard) {
  const {
    ref: moreIconRef,
    setIsVisible: setShowAction,
    isVisible: showAction,
  } = useOutsideClick<HTMLDivElement>(false);

  const handleMoreAction = () => {
    setShowAction(!showAction);
  };

  const handleEdit = () => {
    onEdit && onEdit();
    setShowAction(false);
  };

  const handleRemove = () => {
    onRemove && onRemove();
    setShowAction(false);
  };

  return (
    <AscGenericCard
      className={classNames(
        styles.ground,
        {
          [styles.loading]: loading,
        },
        className
      )}
      loading={loading}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      contentClassName={styles.cardContent}
      title={title}
      customImage={
        <div className={styles.topContent}>
          <img src={imageUrl} alt={imageUrl} className={styles.image} />
        </div>
      }
    >
      <div className={styles.textContainer}>
        <span className={styles.text}>{type}</span>
        <span className={styles.text}>{format}</span>
      </div>
      <div ref={moreIconRef} className={styles.btnMoreWrapper}>
        <MoreIcon
          className={styles.moreIcon}
          data-testid={"asc-skill-card-more-icon"}
          onClick={handleMoreAction}
        />
        {showAction && (
          <AscAdminAction
            option1={"Edit"}
            option2={"Delete"}
            clickOption1={handleEdit}
            clickOption2={handleRemove}
            className={styles.adminAction}
          />
        )}
      </div>
    </AscGenericCard>
  );
}
